// remove once using tag-filter

import { Table } from '@tanstack/react-table'
import SearchFilter from './filters/search-filter'
import BrandFilter from './filters/brand-filter'
import StatusFilter from './filters/status-filter'
import SkillFilter from './filters/skill-filter'
import CreatedByFilter from './filters/created-by-filter'
import FormatFilter from './filters/format-filter'
import UpdatedAtFilter from './filters/updated-at-filter'
import DesignersFilter from './filters/designers-filter'
import ProjectsFilter from './filters/projects-filter'
import { cn } from 'lib/util/cn'
import { LinkLikeButton } from 'components/core/button'
import TagsFilter from './filters/tag-filter-no-edit'
import { useFeatureFlagsContext } from 'lib/components/feature-flags/feature-flags-provider'
export interface FiltersProps<TData> {
  table: Table<TData>
}

export default function Filters<TData>({ table }: FiltersProps<TData>) {
  const { isFeatureFlagEnabled } = useFeatureFlagsContext()

  return (
    <div className={cn('tw-flex tw-flex-wrap tw-items-center tw-gap-2')}>
      <SearchFilter table={table} className="tw-w-[424px]" />
      <TagsFilter table={table} />
      <StatusFilter table={table} />
      {isFeatureFlagEnabled('search_v2') && <ProjectsFilter table={table} />}
      <SkillFilter table={table} />
      <BrandFilter table={table} />
      <UpdatedAtFilter table={table} />
      <DesignersFilter table={table} />
      <CreatedByFilter table={table} />
      <FormatFilter table={table} />
      {table.getState().columnFilters.length > 0 && (
        <>
          <div className="tw-mx-2 tw-h-6 tw-w-px tw-bg-peppercorn-100"></div>
          {/* TODO: Add saved searches back in once we fully launch Elasticsearch */}
          {/* <SaveSearch /> */}
          <LinkLikeButton color="secondary" onClick={() => table.resetColumnFilters(true)}>
            Clear filters
          </LinkLikeButton>
        </>
      )}
    </div>
  )
}
